import { h } from '@stencil/core';
import { send, documentDownloadEvent, isAnalyticsEnabled, getParamValueFromURL, getQdsIconLibrary, EQdsButtonImportance, EQdsButtonSize, pesIconSizes } from '@pes-ui/utils';
import { ACTION_TYPES } from '../asset-bar/constants';
import { ACTION_ICONS_MAP } from './constants';
import { isMobile } from '../../../globals/utils';
export class DocumentDropdown {
  windowSizeDidChange() {
    const currentViewState = isMobile();
    if (this.isMobile !== currentViewState) {
      this.isMobile = currentViewState;
    }
  }
  constructor() {
    this.onDocumentItemHandler = (document) => {
      if (isAnalyticsEnabled()) {
        const { documentReference: documentId, documentName, documentType } = document;
        send(documentDownloadEvent, { documentId, documentName, documentType });
      }
    };
    this.onAdditionalLinkHandler = (url) => {
      var _a, _b;
      if (isAnalyticsEnabled()) {
        const { viewOnline, viewOtherFormats, downloadAll } = this.links;
        switch (url) {
          case downloadAll: {
            const documentId = getParamValueFromURL(url, 'p_Doc_Ref');
            const documentName = (_a = getParamValueFromURL(url, 'p_File_Name|p_Archive_Name|p_FileName')) !== null && _a !== void 0 ? _a : '';
            const documentType = (_b = getParamValueFromURL(url, 'p_enDocType')) !== null && _b !== void 0 ? _b : '';
            send(documentDownloadEvent, { documentId, documentName, documentType });
            break;
          }
          case viewOtherFormats:
          case viewOnline: {
            const { documentReference: documentId, documentType } = this.documentGroup;
            send(documentDownloadEvent, { documentId, documentType, isViewOnline: true });
            break;
          }
        }
      }
    };
    this.renderActionIcon = (type) => {
      const iconTitle = ACTION_ICONS_MAP[type];
      return iconTitle ? (h("pes-icon", { class: "dropdown-item__action-icon", size: this.isMobile ? pesIconSizes.NANO : pesIconSizes.MICRO }, iconTitle)) : null;
    };
    this.renderDocumentsListItem = (document) => {
      const { url, label, extension, size, type } = document;
      const actionIcon = this.renderActionIcon(type);
      return (h("a", { class: "dropdown-item", href: url, target: "_blank", onClick: () => this.onDocumentItemHandler(document) }, h("div", { class: "dropdown-item__label" }, label, this.isMobile && actionIcon), h("div", { class: "dropdown-item__extension" }, extension), h("div", { class: "dropdown-item__size" }, size), !this.isMobile && actionIcon));
    };
    this.renderAdditionalLink = (href, label, type) => {
      const iconTitle = ACTION_ICONS_MAP[type];
      const { download } = ACTION_TYPES;
      if (type === download) {
        return (h("qds-button", { size: EQdsButtonSize.STANDARD, importance: EQdsButtonImportance.SUBDUED, href: href, target: "_blank", text: label, iconName: "arrow-down-tray", iconLibrary: getQdsIconLibrary("arrow-down-tray") }));
      }
      return (h("a", { class: "dropdown-link", href: href, target: "_blank", onClick: () => this.onAdditionalLinkHandler(href) }, label, h("pes-icon", { class: "dropdown-link__icon", size: pesIconSizes.NANO }, iconTitle)));
    };
    this.renderDropdownContent = () => {
      const { viewOnline, viewOtherFormats, downloadAll } = this.links;
      const { viewOnline: viewOnlineLabel, viewOtherFormats: viewOtherLabel, downloadAll: downloadAllLabel, } = this.labels;
      const { redirect, download } = ACTION_TYPES;
      return (h("div", { class: "dropdown-content" }, h("div", { class: {
          'dropdown-content__documents-wrapper': true,
          'dropdown-content__documents-wrapper--scroll': this.documentsQuantity > 6,
        } }, h("div", { class: "dropdown-content__documents" }, this.documents.map(this.renderDocumentsListItem))), h("div", { class: "dropdown-content__links" }, viewOnline && this.renderAdditionalLink(viewOnline, viewOnlineLabel, redirect), viewOtherFormats
        && this.renderAdditionalLink(viewOtherFormats, viewOtherLabel, redirect), downloadAll
        && this.documentsQuantity > 1
        && this.renderAdditionalLink(downloadAll, downloadAllLabel, download))));
    };
    this.documents = undefined;
    this.links = undefined;
    this.labels = undefined;
    this.reference = undefined;
    this.isActive = undefined;
    this.documentGroup = undefined;
    this.isMobile = isMobile();
    this.el.dir = document.documentElement.dir || 'auto';
  }
  get documentsQuantity() {
    return this.documents.length;
  }
  render() {
    if (this.isMobile) {
      return (h("se-dialog", { open: this.isActive, canBackdrop: false, size: "fill" }, h("se-dialog-header", { closeIcon: true }, this.labels.title), h("se-dialog-content", { option: "fill" }, this.renderDropdownContent())));
    }
    return (h("pes-tooltip", { class: "dropdown-tooltip", reference: this.reference, active: this.isActive, option: "fill", placement: "bottom" }, this.renderDropdownContent()));
  }
  static get is() { return "pes-document-dropdown"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["document-dropdown.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["document-dropdown.css"]
    };
  }
  static get properties() {
    return {
      "documents": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TDropdownDocument[]",
          "resolved": "TDropdownDocument[]",
          "references": {
            "TDropdownDocument": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Documents list for dropdown"
        }
      },
      "links": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TDropdownAdditionalLinks",
          "resolved": "{ downloadAll: string; viewOnline: string; viewOtherFormats: string; }",
          "references": {
            "TDropdownAdditionalLinks": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Object with additional links"
        }
      },
      "labels": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TDropdownLabels",
          "resolved": "{ title: string; downloadAll: string; viewOtherFormats: string; viewOnline: string; }",
          "references": {
            "TDropdownLabels": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Object with labels"
        }
      },
      "reference": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "HTMLElement",
          "resolved": "HTMLElement",
          "references": {
            "HTMLElement": {
              "location": "global"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Reference element, which tooltip placement calculations are based on"
        }
      },
      "isActive": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Show dropdown"
        },
        "attribute": "is-active",
        "reflect": false
      },
      "documentGroup": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "DocumentGroup",
          "resolved": "{ documentReference: string; documentType: string; documentName: string; }",
          "references": {
            "DocumentGroup": {
              "location": "import",
              "path": "../asset-bar/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Object with document info about dropdown group"
        }
      }
    };
  }
  static get states() {
    return {
      "isMobile": {}
    };
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "resize",
        "method": "windowSizeDidChange",
        "target": "window",
        "capture": false,
        "passive": true
      }];
  }
}
